export default __webpack_public_path__ + "static/8-0d7c8dfc06a5e2315849c5ba3affdd59.jpeg";